import { Routes } from '@angular/router';
import { CustomMenuService } from '@app/global services';
import { IloginConfig, UnloggedGuard } from 'viggo-sistemas-core-web';

export const routesUnloggedUser: Routes = [
  {
    path: 'catalogo_produto/:domain_name',
    loadChildren: () =>
      import(
        '@app/modules/catalogo-produto-publico/catalogo-produto-publico.module'
      ).then(m => m.CatalogoProdutoPublicoModule)
  },
  {
    path: 'landing',
    loadChildren: () =>
      import('@app/modules/landing-page/landing-page.module').then(
        m => m.LandingPageModule
      ),
    canActivate: [UnloggedGuard]
  },

  {
    path: 'auth',
    loadChildren: () =>
      import('@app/modules/wrapperModules/auth-wrapper.module').then(
        a => a.AuthWrappereModule
      ),
    data: {
      loginConfig: {
        softwareHouseAppName: 'Viggo-Gestor',
        softwareHouselogoTopBar: 'assets/images/icone.png',
        softwareHouseLanding: 'landing',
        softwareHouseSlogan: ' ',
        softwareHouseLogoURL: 'assets/images/logo.png',
        softwareHouseRegisterLogin: true,
        defaultBg: 'assets/images/login-bg.png',
        softwareHouseLimitTokens: true,
        menuService: CustomMenuService // SE FOR USAR O BREADCRUMB COM CAMINHO DOS MENUS PASSE ESSA CLASSE DE SERVIÇO QUE É INSTANCIADA NO CORE
      } as IloginConfig
    }
  },
  {
    path: 'reset/:token_id/:domain_name',
    redirectTo: '/auth/reset/:token_id/:domain_name'
  },
  {
    path: 'activate/:token/:domain_id/:user_id',
    redirectTo: 'landing/activate/:token/:domain_id/:user_id'
  }
];
